import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import ThankYou from "./components/ContactUs/ThankYou";
import PdbData from "./components/PdbData/PdbData";
import ContactUsStep from "./components/Wizard/ContactUsStep";
import MachineTonnageStep from "./components/Wizard/MachineTonnageStep";
import MarketStep from "./components/Wizard/MarketStep";
import OptionalStep from "./components/Wizard/OptionalStep";
import ProductStep from "./components/Wizard/ProductStep";
import { mapLanguage } from "./config/mapLanguage";
import { mapMarket } from "./config/mapMarket";
import { routesConfig } from "./config/routes";
import i18n from "./i18n";
import { cookies } from "./shared/helpers/cookies";
import { Helmet } from "react-helmet";
import { action } from "./store/action";
import { useTranslation } from "react-i18next";

const getCulture = (pathName: string): string => {
  if (pathName === "/") {
    return "sv";
  }
  const segements = pathName.split("/");
  if (segements.length <= 1) {
    return "sv";
  }

  return segements[1];
};

const formatCulture = (culture: string) => {
  const index = culture.indexOf("-");

  if (index > -1) {
    return `${culture.substring(0, index)}${culture
      .substring(index)
      .toUpperCase()}`;
  }

  return culture;
};

const setApplicationLanguage = (culture: string) => {
  if (culture === "sv") {
    i18n.changeLanguage(culture);
    return;
  }

  if (mapLanguage[culture]) {
    i18n.changeLanguage(mapLanguage[culture]);
    return;
  }

  i18n.changeLanguage(formatCulture(culture));
};

const getMarket = (culture: string): string => {
  if (culture === "sv") {
    return "sv-SE";
  }
  //  if (culture === "fr-CA") {
  //    return "en-US";
  //  }

  if (mapMarket[culture.toLowerCase()]) {
    return mapMarket[culture];
  }

  return formatCulture(culture);
};

// const getLanguage = (market: string) => {
//   if (market === "en") {
//     return "en-GB";
//   }

//   return market;
// };

const App = () => {
  const dispatch = useDispatch();
  const searchParams = new URLSearchParams(document.location.search);
  const summaryId = searchParams.get("id");
  const pathName = window.location.pathname;
  const culture = getCulture(pathName);
  const flagMarket = cookies.getFlagMarket();
  const language = flagMarket && !summaryId ? flagMarket : culture;
  const market = getMarket(culture);
  let cookieMarket = cookies.getMarket();
  if(cookieMarket === "en-CA" || cookieMarket === "en-NZ")
  cookieMarket = undefined;
  const { t } = useTranslation("seo");

// && market !== "en-US" && cookieMarket === "fr-CA"
  if (cookieMarket && (market !== cookieMarket && (language !== "fr-CA" && language !== "fr-BE" && language !== "nl-BE")) && !summaryId) {
    window.location.href = routesConfig[cookieMarket].marketStep;
  }
  if(language === "fr-CA" && culture === "en-us" && !summaryId) {
    window.location.href = routesConfig[language].marketStep;
  }
  if(language === "fr-BE" && culture === "nl-nl" && !summaryId) {
    window.location.href = routesConfig[language].marketStep;
  }
  if(language === "nl-BE" && culture === "nl-nl" && !summaryId) {
    window.location.href = routesConfig[language].marketStep;
  }



  // Only necessary for dev (localhost)
  if (pathName === "/") {
    window.location.href = routesConfig.sv.marketStep;
  }

  setApplicationLanguage(language);

  useEffect(() => {
    dispatch(action.saveMarket(market));

    // const productGuideConfig = productGuideLanguage;
    // productGuideConfig.uri = pathName;
    // productGuideConfig.language = getLanguage(market);
    // dispatch(saveAppDetails(productGuideConfig));
  }, [dispatch, market]);
  let routeMarket = market === "sv-SE" ? "sv" : market;
  if(language === "fr-CA" && market === "en-US") {
    routeMarket = language;
  }
  if(language === "fr-BE" && market === "nl-NL") {
    routeMarket = language;
  }
  if(language === "nl-BE" && market === "nl-NL") {
    routeMarket = language;
  }
  const routes = routesConfig[routeMarket];

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{t("startpage.titel")}</title>
        <meta name="description" content={t("startpage.text")} />
        <meta name="keywords" content={t("startpage.keywords")} />
      </Helmet>
      <PdbData />
      <BrowserRouter>
        <Route
          exact
          path={routes.marketStep}
          component={() => <MarketStep />}
        />
        <Route
          exact
          path={routes.machineTonnageStep}
          component={() => <MachineTonnageStep />}
        />
        <Route
          exact
          path={routes.productStep}
          component={() => <ProductStep />}
        />
        <Route
          exact
          path={routes.otherOptionsStep}
          component={() => <OptionalStep />}
        />
        <Route
          exact
          path={routes.contactUsStep}
          component={() => <ContactUsStep />}
        />
        <Route
          exact
          path={routes.thankYouStep}
          component={() => <ThankYou />}
        />
      </BrowserRouter>
    </>
  );
};

export default App;
